import { RenderPipeline } from '../RenderPipeline'
import type { AnalyticsCardOutput } from './AnalyticsCard'

const setAnalyticsCard = () =>
  RenderPipeline.updateOutput((_output: Partial<AnalyticsCardOutput>) => ({
    analyticsCard: {
      contentPadding: 16,
      headerPaddingX: 16,
      headerPaddingY: 8,
    },
  }))

export const AnalyticsCardOutputParts = {
  setAnalyticsCard,
}
